export default "__VITE_ASSET__O7VNCxN0__"